import { useStoreSelector } from '@hook/store/store.hooks';

export const useRouteName = () => useStoreSelector((state) => state.route.name);
